export default {
    home: "首页",
    venueFastQuery: "一键查询",
    venueFastQueryOld: "一键查询",
    cardNumberManagement: "卡号管理",
    cardDetail: "卡号详情",
    cardNumberAssignment: "卡号分配",
    changeIp: "改变线路",
    batchChangeIp: "批量改变线路",
    cdrListToday: "当天的CDR清单",
    wirteCardMissingQuery: "写卡遗漏查询",
    merchantManagement: "商户管理",
    agentManagement: "代理商管理",
    packageManagement: "套餐管理",
    packageResources: "套餐资源",
    statisticalReport: "统计报表",
    roleManagement: "角色管理",
    userActionLog: "用户操作日志",
    rechargeLog: "账户流水",
    topUpLog: "充值日志",
    taskTopupList: "充值任务",
    orderFile: '订单文件',
    changeRoute: '改变线路',
    routeRate: '线路费率',
    agentIpFeeLogList: "线路费用明细",
    withdrawLog: "撤回套餐日志",
    actionCode: '类型',
    cdrSimList: 'SIM CDR',
    keyword: "请输入关键字查询!",
    queryFail: "查询失败！",
    noData: "暂无数据",
    loading: "正在获取数据...",
    switchLanguages:"语言",
    simplifiedChinese: "简体中文",
    personalInformation: '个人信息',
    logout:'退出',
    english: "English",
    all: "全部",
    package:'套餐',
    packageDetail:'套餐详情',
    globalMsisdnPackage:'号码包',
    selected: '已选中',
    operator: '操作者',
    type: '类型',
    operationSuccess: '操作成功',
    importFail: '导入失败',
    exportData: '导出数据',
    remainingImsi: '剩余数量(IMSI)',
    pleaseEnter:'请输入...',
    noticeAccountExpired:'账号已过期,请重新登录!',
    backTop:'返回顶端',
    day: "天数",
    contact: "联系客服",
    noPackageData:"暂无套餐信息",
    clearPackageData:"套餐已清空",
    nonSupportRecharge:"套餐价格为空，不能充值!",
    otaSimManage:"OTA卡号管理",
    otaPackageManage:"OTA套餐管理",
    taskId: '批次号',
    accountStatus:{
        inactive:'未激活',
        activated:'已激活',
        close: '已关闭',
        expired:'已过期',
        HLRTerminated:'已销户'
    },
    addMerchantMember:'添加商户成员',
    other: '其他',
    common:{
        search:"搜索",
        reset: '重置',
        available:'可用',
        disable:"禁用",
        clear: '清除',
        clearIpGroup: '清除线路',
        enable:"启用",
        assign:"分配",
        edit:'编辑',
        notice: "提示",
        confirmDelete: '你确定删除？',
        cardSearch: '请输入卡号搜索',
        ok:'确定',
        cancel:'取消',
        close:'关闭',
        batchClose:'批量关闭',
        editAssign:"编辑分配",
        add: "增加",
        recharge: "充值",
        deduction: "扣款",
        other: '其他',
        unlimit:"无限",
        pleaseChoose: "请选择...",
        present: "赠送套餐",
        accountStatus:{
            inactive:'未激活',
            activated:'已激活',
            close: '已关闭',
            expired:'已过期',
            HLRTerminated:'已销户'
        },
        packageStatus:{
            inactive:'未激活',
            activated:'已激活',
            close: '已关闭',
            expired:'已过期'
        },
        payType:{
            prepay:'预付',
            postpay:'后付',
        },
        byType:{
            segment: '按号段',
            number: '按数量',
            scattered: '零散的',
        },
        account: "卡号",
        agent: "代理商",
        productName: "套餐名",
        businessOwner: "所属商户",
        batchTopup: '批量充值',
        batchRecharge: "Excel 批量充值",
        currImsi: "IMSI",
        pkgStatus: "套餐状态",
        status: "状态",
        cardStatus: "卡状态",
        delete: "删除",
        operation: "操作",
        contact:'联系人',
        transfer:'转账',
        address:'地址',
        phone:'手机号',
        operator:'操作者',
        createTime:'创建时间',
        viewDetails:'查看详情',
        rate: '费率',
        viewPackage: '查看套餐',
        temp:'下载充值模板',
        editAgentPassword:'修改密码',
        havePackage:'已有套餐',
        areYouSureContinue:'你确定要继续操作吗？',
        topupExcelNotice:'请清除已有相同套餐的卡，再重新上传文件',
        bossId:'BOSS',
        currDataSpeed:'当前速率',
        fixExpiryTime:'促销过期时间',
        onSale:'是否上架',
        pleaseInput:'请输入',
        upShelf:'上架',
        downShelf:'下架',
        cardExpiryTime:'卡有效期(月)',
        provider:'供应商',
        class:'卡类别',
        isOta: '是否OTA',
        no:'否',
        yes:'是',
        syncProductNotice:'你确定要同步产品信息吗？',
        syncOperateSuccess:'同步产品成功！',
        syncOperateFail:'同步产品信息失败...',
        method: '方式',
        accounts: '卡号',
        accounts_placeholder: '请输入卡号一行一个',
        account_placeholder: '请输入起始卡号和结束卡号',
        continuity:'连续卡号',
        nonContinuity: '非连续卡号',
        accountStart: '起始卡号',
        accountEnd: '结束卡号',
        batchChangeIp: '批量改变线路',
        ipGroup: '线路组',
        changeIpType: '改线路计费方式',
        changeIpTypeOp:{
            byCount: '按次',
            perMensem: '包月'
        },
        changeAccountObject: '计费对象',
        changeAccountObjectOp:{
            account: '卡号',
            imsi: 'IMSI'
        },
        packageSearch: '套餐查询',
        routeSearch: '线路查询',
        addChangeIpRate: '新增费率',
        effectiveStartTime : '生效日期',
        effectiveEndTime : '失效日期',
        editChangeIpRate: '编辑费率',
        effectiveEndMonth: '开通月数',
        fupType: '限速类型',
        fupType_0: "未知",
        fupType_1: "天卡",
        fupType_2: "总量卡",
        packageRechargeFee: "套餐充值扣费",
        packageCancellationRefund: "套餐撤销退费",
        cancellationServiceFee: "套餐撤销手续费",
        balanceCredit: "财务增加金额",
        balanceDeduction: "财务扣减金额",
        eSIMIssuanceFee: "eSIM生成手续费",
        lineChangeFee: "IP变更手续费",
        lineMonthlyRentalFee: "线路月租",
        activeImsiFee: "活跃IMSI扣费"
    },
    fastQuery:{
        esimDetail: 'Esim信息',
        esimStatus: 'Esim 状态',
        esimInstallationCount: 'Esim 安装次数',
        esimInstallTime: 'Esim 安装时间',
        esimInstalledDevice: 'Esim 安装设备',
        topupStatus: '充值状态',
        search: "请输入IMSI或卡号搜索...",
        nodata: "无",
        basicInfo: "基本信息",
        account: '卡号',
        currImsi: "IMSI",
        cardType: "卡类型",
        enable: "是否可用",
        accountStatus: "卡号状态",
        payType: "付款类型",
        balance: "余额",
        dataUsageToday: "今天已使用流量",
        dataUsageTotal: "已使用",
        voiceTotal: "语音分钟数",
        voiceMtTotal: "语音呼入分钟数",
        voiceMoTotal: "语音呼出分钟数",
        smsTotal: "发短信数",
        packageStatus: "套餐状态",
        validMonth: "有效期(月)",
        packageActiveTime: "套餐激活时间",
        packageExpiryTime: "套餐过期时间",
        createTime: "创建时间",
        packageType:'套餐类型',
        bindImsiData:{
            bindData: "绑定信息",
            serialNumber: "序号",
            bindImsi: "绑定的IMSI",
            bindTime: "绑定时间",
        },
        ratePackageTitle: '费率套餐',
        dataPackage: '套餐',
        product:{
            syncProduct: '同步产品',
            addProduct:'创建套餐',
            editProduct:'编辑套餐',
            delProduct:'删除',
            batchDelProduct:'批量删除',
            information: "套餐信息",
            productId: "套餐ID",
            productName: "套餐名称",
            validDays: "有效期(天)",
            dataTotal: "总流量",
            voiceTotal: "语音总分钟数",
            voiceMt: "语音呼入分钟数",
            voiceMo: "语音呼出分钟数",
            smsTotal: "短信总数",
            dataSpeedDefault: "默认限速",
            dataQuota: "Quota Data",
            validDayType: "有效期类型",
            validDayTypeObj:{
                hours:'24小时',
                day: '1天'
            },
            rateGroupName: "费率组名称",
            zoneVoiceMtName: "支持呼入语音区域",
            zoneVoiceMoName: "支持呼出语音区域",
            zoneDataName: "支持上网区域",
            zoneSmsName:"支持短信区域",
            dataFupName:"上网限速策略",
            voiceFupName:"语音限速策略",
            operator:{
                information: "运应商信息",
                name: "名称",
                countryName: "国家名称",
                countryCode: "国家编码缩写"
            },
        },
        cdr:{
            cdrTodayTitle: "当天CDR",
            cdr30TodayTitle: "30天内CDR",
            billTime: "计费时间",
            startTime: "开始使用时间",
            account: "卡号",
            imsi: "IMSI号码",
            msisdn: "MSISDN号码",
            mccmnc: "MCCMNC",
            imei: "IMEI识别码",
            sgsn: "SGSN",
            ratType: "网络类型",
            opId: "运营商ID",
            ccId: "国家区号",
            usage: "使用流量",
            providerId: "供应商ID",
            agent: "代理商",
            productId: "套餐ID",
            rate: "费率",
            fee: "费用",
            balanceAgent: "代理商余额",
            requestType: "请求类型",
            usageIn: "下载流量",
            usageOut: "上网流量",
            balance: "余额"
        },
        accUserMsisdnPackage: '号码套餐信息',
        accUserBindMsisdn: '号码信息',
        bindMsisdn: '绑定号码',
        msisdnProduct: '号码产品'
    },
    oldFastQuery:{
        search: "请输入IMSI或卡号搜索...",
        basicInfo: "基本信息",
        agent: "代理商",
        status: "状态",
        cardId: "卡号",
        imsiStatusBICS:{
            inactive:'未激活',
            activated:'已激活',
            freezed: '已冻结'
        },
        imsiStatusMB:{
            inactive: "未激活",
            activated: "已激活",
            expired: "已过期"
        },
        simStatusObj:{
            inactive:'未激活',
            published:'已发布',
            activated:'已激活',
            expired: "已过期",
            disabled: '已禁用',
            deleted: '已删除'
        },
        enable: "是否可用",
        location: "激活地",
        openTime: "开户时间",
        actTime: "激活时间",
        closeTime: "销户时间",
        expTime: "过期时间",
        simStatus: 'SIM状态',
        productName: "套餐",
        product:{
            information: "套餐信息",
            productId: '套餐ID',
            productName: '套餐名',
            days: '有效期',
            quota: '总流量',
            pkgStatus: "套餐状态",
            usage: '已使用流量',
            surplusFlow: '剩余流量数据',
            location:'漫游地',
            agent: "代理商",
            today: "当日使用流量数据",
            source: "漫游地",
            openTime: "开通日期",
            createTime: "创建日期",
            expTime: "过期日期",
            pkgUpTime: "套餐更新时间",
            provider: "供应商",
            packageStatus:{
                inactive:'未启用',
                activated:'已启用',
                close: '已关闭',
                expired:'已过期',
                ReadyDelete:'准备删除'
            }
        },
        cdr:{
            cdrTodayTitle: "当天CDR",
            usage: "数据流量",
            location: "地区",
            openTime: "CDR开始时间",
            closeTime: "CDR结束时间"
        },
        imsiStatusSCT:{
            noOpenAccount: "未开户",
            inactive: "未激活",
            activated: "已激活",
            locked: "已锁定",
            close: "已销户",
            closing:"正在销户"
        }
    },
    account: {
        startAccount: "请输入开始卡号搜索...",
        endAccount: "请输入结束卡号搜索...",
        startImsi: "请输入开始IMSI搜索...",
        endImsi: "请输入结束IMSI搜索...",
        agent: "请输入代理商搜索...",
        taskid: "请输入TASK搜索...",
        pleaseSelectAccount: "请选择卡号",
        enableStatusPleaseSelect:'为启用状态，请重新选择',
        disableStatusPleaseSelect:'为禁用状态，请重新选择',
        differentProviderNotice:'卡号供应商不一致，请重新选择！',
        diffrrentAgentNotice:'卡号代理商不一致，请重新选择！',
        incorrectformat: '文件格式不正确',
        excelFileFormatNotice: ' 格式不正确，请上传.xls,.xlsx文件。',
        file: "文件",
        withdrawPackage: "撤回套餐",
        nonsupportWithDraw:'该套餐暂时不能撤回操作',
        noticeServiceRecharge:'撤回套餐扣一元手续费，你确定继续吗？',
        areYouSure: '你确定撤回套餐？',
        repeatRecharge:'本卡套餐已多次充值，不支持撤回操作',
        withdrawFail:'撤回失敗',
        tempNotice:"(1)、单次最大支持50张；</br>(2)、每次充值套餐资源必须与SIM资源一致。",
        topupTaskNotice:"(1)、单次最大支持10000张；</br>(2)、每次充值套餐资源必须与SIM资源一致。",
        differentBossNotice:"卡号类别不一致，请重新选择！",
        balanceError: "扣款后余额不能小于0!",
        getIpGroupError: "获取线路失败,点击确定查看详情",
        clearIpGroupError: "清除线路失败,点击确定查看详情",
        changeIpGroupError: "改变线路失败,点击确定查看详情",
        searchIpGroupError: "查询线路失败,点击确定查看详情",
    },
    assign: {
        account: "卡号",
        startAccount: "起始卡号",
        endAccount: "结束卡号",
        batchAssign: "批量分配",
        assignMerchant: "分配商户",
        pleaseStartAccount: '请输入起始卡号',
        pleaseEndAccount: '请输入结束卡号',
        count: '数量',
        pleaseEnterCount:'请输入数量',
        pleaseEnterAccount: '请输入卡号',
    },
    bindAssign:{
        requiredAccount: '卡号不能为空',
        requiredMerchant: '商户不能为空',
        dataVerifiyFail: '数据验证失败',
    },
    recharge:{
        cardNumberRecharge: "卡号充值",
        latestPackage: '套餐',
        use: '使用情况',
        chargePackage:'充套餐',
        extendedDays:'延长天数',
        superposition: '充值(叠加)',
        chargeAmount:'充值(金额)',
        changeIpFee: '改变线路费用',
        totalUasge:'总使用流量',
        rechargeInfo:'充值信息',
        rechargeType:'类型',
        packageSelect: '套餐选择',
        renewalBasePackageSelect: '目标套餐选择',
        renewalPackageSelect: '续期产品选择',
        pleaseChoosePackage: '请选择套餐',
        pleaseEnterDay:'请输入天数',
        pleaseEnterMoney:'请输入金额',
        pleaseEnterFlow:'请输入流量',
        repeatPackageNotice:'最新套餐是当前套餐，请选择其他套餐',
        refund:'退款',
        flow: '流量',
        rechargeFlow:'充流量',
        flowLimitType1: '无限流量套餐不能充流量',
        flowLimitType2: '该套餐已过期不能充流量',
        remark:'充值备注',
        title_1: '告警',
        message_1: '尊敬的',
        message_2: '您好!您的当前余额',
        message_3: '已低于告警阈值,如有需要可提前进行充值',
        typeOptions: {
            add: '充值(新增)',
            coverage: '充值(覆盖)',
            merging: '充值(叠加)',
            renewal: '充值(续期)',
            flow: '充值(流量)',
            day: '充值(天数)'
        },
        current_charge_log:'当前充值记录',
        total_num:'总数',
        success_num:'成功数',
        failed_num:'失败数',
        success_list:'成功列表',
        loading_data:'正在获取数据...',
        failed_list:'失败列表',
        account_sn:'卡号',
        boss_package_id:'Boss套餐ID',
        result:'结果'
    },
    productList: {
        zoneName: '区域名',
        zoneID: '区域ID',
        price: '单价',
        actived: '激活状态',
        pleaseEnterZone:'请输入区域搜索...',
        pleaseEnterPackageID:'请输入套餐ID搜索...',
        pleaseEnterPackageName:'请输入套餐名搜索...',
    },
    statistics:{
        date: '日期',
        selectDate: '选择日期',
        accountCount: '卡号个数',
        activatedAccountNum:'卡号激活数',
        useUsage: '使用流量',
        userNum: '用户个数',
        hj:'合计'
    },
    log:{
        startTime: '开始时间',
        endTime: '结束时间',
        packagePrice: '套餐价格',
        prechangeAgentBalance: '变动前余额',
        changedAgentBalance: '变动后余额',
        changeAmount: '变动金额',
        description: '提示信息',
        remark: '备注信息',
        operationTime: '操作时间',
        status: '状态',
        success: '成功',
        fail:'失败',
        operator:'操作人',
        serviceCharge: '手续费',
        numberOfSuccesses:'成功数',
        numberOfFailures:'失败数',
        packageDeduction:'套餐扣费',
        refund:'退款',
        handlingFee :'手续费',
        rechargeAmount:'充值(金额)',
        accountBalance:'账户余额',
        agentRechargeLog:'代理商充值流水',
        agentWithdrawLog:'代理商撤回套餐日志',
        paymentSuccess:'扣款成功',
        rechargeSuccess:'充值成功',
        refundSuccess:'退款成功',
        billingState:'计费状态',
        tId:'交易单号',
        otaRechargePackage:'OTA充套餐',
        eSIMGenerateFee:'eSIM生成费用',
    },
    writeCardQuery:{
        totalNumCards:  '卡总数',
        totalNumWritenCards:  '已写卡总数',
        totalNumWaitingCards:  '等待卡总数',
        totalNumFailedCards:  '失败卡总数',
        totalNumUsedIMSIs:  '已使用IMSI总数',
        totalNumRepeatedCards:  '重复写卡总数',
        totalNumUnwrittenCards:  '未写卡总数',
        totalNumRecoveredCards:  '已回收卡总数',
        unwrittenCardInformation: '未写的卡信息',
        repeatCardInformation: '重复的卡信息',
        repeatIMSIInformation: '重复的IMSI信息',
        waitingCardInformation: '等待的卡信息',
        failedCardInformation: '失败的卡信息',
        recoveredCardCards: '已回收的卡信息',
        num: '数量',
        pleaseenterKeyword: '请输入开始卡号和结束卡号查询！',
        dateverify: '开始卡号应小于或等于结束卡号！',
    },
    merchant:{
        username:'账号',
        password:'密码',
        shopName:"店铺名",
        selectCombox: '请选择',
        selectUsername:'请选择账号',
        pleaseEnterShopNameSearch:'请输入店铺名搜索...',
        editMerchant:'编辑新商户',
        addMerchant:'注册新商户',
        requiredUsername:'请填写账号',
        requiredPassword:'请填写密码',
        requiredRoleId:'请选择角色',
        requiredPasswordLength:'密码长度不能小于6位',
        requiredMaxNameLength:'套餐名长度最大200字节',
        requiredShopName:'店铺不能为空',
        requiredAgent:'请填写代理商',
        correctFormatPhone:'请填写正确的手机号'
    },
    agent:{
        username:'账号',
        password:'密码',
        nickname:'昵称',
        role:'角色',
        balance:'余额',
        alert_balance: '告警余额',
        email: '邮件地址',
        remark: '备注',
        pleaseEnterUsernameSearch:'请输入账号搜索...',
        pleaseEnterNicknameSearch:'请输入昵称搜索...',
        editAgent:'编辑代理商',
        registerAgent:'注册代理商',
        developing:'此功能暂时不能使用，开发中',
        oldPassword:'旧密码',
        newPassword:'新密码',
        confirmPassword:'确认新密码',
        editPassword:'修改密码',
        enable:'启用',
        secret: '密钥',
        priceUnit: '币种',
        platform: '平台',
        mgw_balance: '流量结算余额',
        parent_account: '父级代理帐号',
        per_mensem_last_time: '包月扣费日期'
    },
    productImsi:{
        maximumSupportAuantity:'支持最大导出10000条,你确定要导出？',
        agentResource:'代理商套餐资源',
        exportSuccess:'导出成功'
    },
    role:{
        roleName:'角色名称',
        roleCode:'角色编码',
        searchRole:'请输入角色名称搜索',
        description:'描述',
        addRole:'添加角色',
        editRole:'编辑角色',
        permission:'权限',
        assignPermission:'分配角色权限',
        save:'保存',
        close:'关闭',
        requiredRoleName:'请填写角色名称',
        requiredRoleCode:'请填写角色编码',
        home: '主页',
        reload:'请刷新页面重试',
        saveSuccess:'保存成功'
    },
    actionLog:{
        usernameId:'用户ID',
        usernameSearch:'请输入用户账号搜索...',
        parametersSearch:'请输入参数搜索...',
        moduleName:'模块名',
        requestMethod:'请求方式',
        requestParameters:'请求参数',
        requestPath:'请求路径',
        description:'描述',
        createTime:'操作时间',
        seeParametersDetail:'查看参数详情',
        parameters:'参数'
    },
    taskTopup:{
        taskNo: '任务编号',
        status: '状态',
        uploadTask: '上传任务',
        uploadTopupFile: '上传充值文件',
        topupMode: '充值模式',
        selectTopupMode: '请选择充值模式',
        topupAdd: '充值(新增)',
        topupCover: '充值(覆盖)',
        topupRenewal: '充值(续期)',
        uploadFile: '上传文件',
        clickUpload: '点击上传',
        cardNo: '卡号',
        productId: '产品ID',
        errorInfo: '异常信息',
        topupSuccessList: '充值成功列表',
        topupFailList: '充值失败列表',
        cardCount: '卡总数',
        fileCount: '上传文件数',
        successCount: '成功数',
        failCount: '失败数',
        taskTime: '耗时',
        agent: '代理商',
        completeTime: '完成时间',
        createTime: '创建时间',
        createDataDoing: '建立数据中',
        completeCreateData: '建立数据完成',
        checkDataDoing: '校验数据中',
        checkDataFail: '校验数据失败',
        topupDoing: '充值中',
        topupFail: '充值失败',
        completed: '已完成',
        viewInfo: '查看信息',
        reUpload: '重新上传',
        downFile: '下载文件',
        no: '序号',
        information: '信息',
        success: '成功',
        fail: '失败',
        topupTime: '充值时间',
        noOperatePermission: '没有权限操作',
        pleaseUploadFile: '请上传文件',
        comfirmSubmitTask: '充值任务，您确定提交？',
        operateFailed: '操作失败',
        confirmSubmit: '您确定提交？',
        confirmDownFile:'您确定要下载文件？',
        loadingFailed:'加载失败',
        clickView: '点击查看',
    },
    agentIpFeeLog: {
        date: '日期',
        ipGroup: '线路',
        country: '国家',
        specifyIpRate: '特殊线路费率(/M)',
        specifyIpUsage: '特殊线路用量(M)',
        specifyIpFee: '特殊线路费用',
        otherRate: '其它线路费率(/M)',
        otherUsage: '其它线路用量(M)',
        otherFee: '其它线路费用',
        totalFee: '总费用'
    },
    esimPurchase: '订购Esim',
    esimPurchaseCommon: {
        purchaseStatus:{
            title: '状态',
            inactive:'未开始',
            activated:'进行中',
            completed: '完成',
            stoped: '已停止'
        },
        count: '订购数量',
        successCount: '成功数量',
        failedCount: '失败数量',
        faileMessage: '失败说明',
        product: '产品',
        searchProduct: '产品ID | 产品名称(支持模糊搜索)',
        purchase: '订购',
        packageSelect: '选择产品',
        packagePrice: '产品价格',
        noPackage: '请选择产品',
        minCount: '最少订购数量为 1',
        maxCount: '最大订购数量为 1000',
        noRemark: '请填写备注',
        email: '电子邮件',
        emailErr: '电子邮件不正确',
        remark: '备注',
        repeatSubmit: '正在订购，请勿重复操作',
        purchaseSuccess: '订购成功',
        purchaseTime: '订购时间',
        purchaseStop: '停止订购',
        download: '下载Esim',
        sendToEmail: '发送到邮件',
        purchaseDetail: '订购详情',
        account: '卡号',
        qrcode: '二维码',
        lpa: '查看eSIM详情',
        sendToEmailSuccess: '发送成功',
        sendToEmailFailed: '发送失败',
    }
};



// WEBPACK FOOTER //
// ./src/language/zh-CN.js